import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-surveys-quick-actions',
  template: require('./surveys-quick-actions.component.html')
})
export class SurveysQuickActionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/surveys-quick-actions/surveys-quick-actions.component.ts